import { DatasetCreation, DatasetSource, DatasetStatus } from '~/api/types';

export enum DatasetCreationStepsEnum {
  DETAILS = 0,
  DATA_TAGS = 1,
  DATA_MEMBERS = 2,
}

export const initialDefaults: DatasetCreation = {
  name: '',
  description: '',
  data_classification: undefined,
  provenance: undefined,
  type: 's3 external', // mocked default value
  status: DatasetStatus.IN_PROGRESS,
  data_format: [],
  de_identified: undefined,
  restriction_tag: null,
  legal_relationship_tag: '',
  legal_relationship_qualifier_tag: null,
  secondary_data_owners: [],
  secondary_data_owner_network_ids: [],
  data_uploaders: [],
  data_uploaders_network_ids: [],
  geo_location_tags: [],
  source: DatasetSource.HDP,
  anatomy: [],
  modality: [],
  dimensionality: [],
  wbs_code_id: undefined,
  cost_center_id: undefined,
  // mocked
  visit_type: false,
  have_sites: false,
};
